module.exports = __webpack_public_path__ + "img/1024x1024-01.6ef3c9de.png";